define([
    'jQuery',
    'Emitter',
    'system/mediators/DialogManager',
    './billing-registration-mediator',
    '../blocks/billing-balance-replenished/billing-balance-replenished',
], ($, Emitter, DialogManager, Registration, BalanceReplenishedView) => {
    'use strict';

    const { Environment } = require('Environment');

    /**
     * @constructor
     * @param {Object} options
     * @param {Balance} options.balanceModel
     */
    function RegistrationReminder(options) {
        this._balanceModel = options.balanceModel;
        this._check();
    }

    RegistrationReminder.fn = RegistrationReminder.prototype = {
        _showRegistrationDialog() {
            new Registration().start().then(
                () => {
                    this._balanceModel.set('legal_form', 'pending');
                },
                () => {},
            );
        },

        _showValidationMessage() {
            return DialogManager.alert({
                header: 'Проверка данных',
                message:
                    'Регистрационные данные приняты и находятся ' +
                    'на рассмотрении. После проверки данных вам станет ' +
                    'доступно выставление счетов для оплаты. ' +
                    'Если у нас возникнут вопросы или комментарии, ' +
                    'то мы обязательно свяжемся с вами. ' +
                    'Обычно, рассмотрение заявки занимает до 2х дней.',
                ok: 'OK',
            });
        },

        _onRegister() {
            const legalForm = this._balanceModel.get('legal_form');

            if (legalForm === 'unknown') {
                this._showRegistrationDialog();
            } else if (legalForm === 'pending') {
                this._showValidationMessage();
            }
        },

        /**
         * @param {boolean} [optionalRegistration]
         */
        _showBalanceReplenishedDialog(optionalRegistration) {
            const view = new BalanceReplenishedView({
                el: $('<div/>').appendTo('.layers'),
                data: {
                    optional: optionalRegistration,
                },
            });

            view.on('register', this._onRegister.bind(this));
            view.show();
        },

        _check() {
            if (Environment.isPrivateBuild) {
                return false;
            }

            const extra = this._balanceModel.get('extra');

            if (this._balanceModel.get('legal_form') === 'unknown' && extra) {
                if (extra.first_pay_order) {
                    this._showBalanceReplenishedDialog(false);
                } else if (extra.first_pay_dmr && !extra.reg_notified) {
                    this._showBalanceReplenishedDialog(true);
                }

                if (!extra.reg_notified) {
                    this._balanceModel.saveExtra('reg_notified', true);
                }
            }
        },
    };

    Emitter.apply(RegistrationReminder.fn);

    return RegistrationReminder;
});
